module.exports = __webpack_public_path__ + "img/frame-mb.51c9d7cd.webp";